import Skeleton from 'react-loading-skeleton'

const LastTalentsSkeleton = () => {
  return (
    <Skeleton
      containerClassName="w-100"
      count={3}
      style={{
        height: '154px',
      }}
    />
  )
}

export default LastTalentsSkeleton
